export const enum ANALYTICS_EVENTS {
  PAGE_LOAD = 'page-load',
  PAGE_LOAD_LOGIN = 'page load',
  MODAL_LOAD_LOGIN = 'modal load',
  CLICK = 'click',
  ERROR = 'error',
  CUSTOM = 'custom',
  RIGHT_ARROW = 'right arrow',
  HERO_CLICK = 'hero click',
  TILE_CLICK = 'tile click',
  BANNER_CLICK = 'banner click',
  HERO = 'hero',
  TILE = 'tile',
  BANNER = 'banner',
  ASSET_ID_BANNER = 'ban'
}

export const enum EVENT_CLICK_TYPE {
  BUTTON = 'button',
  LINK = 'link'
}

export const enum USER_LOGGED_IN_STATUS {
  AUTHENTICATED = 'authenticated',
  UNAUTHENTICATED = 'unauthenticated',
  LOGIN_SUCCESS = 'log-in-success',
  LOGIN_FAILURE = 'log-in-failure',
  LOGIN_FAILED = 'LOGIN_FAILED',
  LOGIN_AUTHENTICATION_FAILED = 'Login authentication failed',
  HOT = 'hot',
  WARM = 'warm',
  COLD = 'cold'
}

export const HEADER_MENU = {
  BOOK: {
    NAME: 'book',
    PAGE_SECTION: 'header:book',
    FLIGHT_SEARCH: {
      NAME: 'flights:search',
      PAGE_SECTION: 'header:book:flights'
    },
    STAYS_SEARCH: {
      NAME: 'stays:search',
      PAGE_SECTION: 'header:book:stays'
    },
    CARS_SEARCH: {
      NAME: 'cars:search',
      PAGE_SECTION: 'header:book:cars'
    },
    VACATIONS_SEARCH: {
      NAME: 'vacations:search',
      PAGE_SECTION: 'header:book:vacations'
    },
    CRUISES: {
      NAME: 'cruises',
      PAGE_SECTION: 'header:book:cruises'
    }
  },
  CHECK_IN: {
    NAME: 'check in',
    PAGE_SECTION: 'header:check in'
  },
  MY_TRIPS: {
    NAME: 'my trips',
    PAGE_SECTION: 'header:my trips',
    DELTA_STAYS: {
      NAME: 'my trips:delta stays',
      PAGE_SECTION: 'header:my trips:delta stays'
    },
    DELTA_CAR_RENTALS: {
      NAME: 'my trips:delta car rentals',
      PAGE_SECTION: 'header:my trips:delta car rentals'
    }
  },
  FLIGHT_STATUS: {
    NAME: 'flight status',
    PAGE_SECTION: 'header:flight status'
  },
  GLOBAL_SEARCH: {
    NAME: 'search icon click',
    PAGE_SECTION: 'header:global nav'
  },
  HOMEPAGE: {
    NAME: 'homepage',
    PAGE_SECTION: 'homepage:'
  },
  TRAVEL_INFO: {
    NAME: 'travel info',
    PAGE_SECTION: 'header:travel info'
  },
  SKYMILES: {
    NAME: 'skymiles',
    PAGE_SECTION: 'header:skymiles'
  },
  NEED_HELP: {
    NAME: 'need help',
    PAGE_SECTION: 'header:need help'
  },
  LOGIN: {
    NAME: 'login',
    PAGE_SECTION: 'header:login'
  }
};

export const enum HEADER_TOP_MENU {
  BOOK = 'BOOK',
  CHECK_IN = 'CHECK_IN',
  MY_TRIPS = 'MY_TRIPS',
  FLIGHT_STATUS = 'FLIGHT_STATUS',
  GLOBAL_SEARCH = 'GLOBAL_SEARCH',
  TRAVEL_INFO = 'TRAVEL_INFO',
  SKYMILES = 'SKYMILES',
  NEED_HELP = 'NEED_HELP',
  LOGIN = 'LOGIN'
}

export const enum HEADER_MENU_BOOK {
  FLIGHT_SEARCH = 'FLIGHT_SEARCH',
  STAYS_SEARCH = 'STAYS_SEARCH',
  CARS_SEARCH = 'CARS_SEARCH',
  VACATIONS_SEARCH = 'VACATIONS_SEARCH',
  CRUISES = 'CRUISES'
}

export interface MenuSection {
  NAME: string;
  PAGE_SECTION: string;
}

export type SecondaryNavigationID = 'secondarynav' | 'sky-miles' | 'more';
